import clearSearchBox from '../actions/clearSearchBox';
import getScenarioStore from '../store/getScenarioStore';
import { createDefaultSearchStore } from '../store/store';
import { ObservableMap } from 'mobx';
import { PillSuggestion } from 'owa-search-service';
import { mutator } from 'satcheljs';

mutator(clearSearchBox, actionMessage => {
    const store = getScenarioStore(actionMessage.scenarioId);
    const defaultSearchStore = createDefaultSearchStore();

    // Clear suggestion pills.
    store.suggestionPillIds = defaultSearchStore.suggestionPillIds;
    store.suggestionPills = new ObservableMap<string, PillSuggestion>();

    // Clear segments.
    store.suggestionSegments.clear();

    // Clear plain text search query.
    store.searchText = defaultSearchStore.searchText;
});
